module.exports = [
  {
    path: '/',
    name: 'index',
    component: require('../components/Index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: require('../components/About.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: require('../components/Contact.vue')
  },
  {
    path: '/work',
    component: require('../components/work/Index.vue'),
    children: [
      {
        path: '',
        name: 'work',
        component: require('../components/work/Overview.vue')
      },
      {
        path: 'incubes',
        name: 'incubes',
        component: require('../components/work/Incubes.vue')
      },
      {
        path: 'clean-sound',
        name: 'clean-sound',
        component: require('../components/work/CleanSound.vue')
      },
      {
        path: 'get-clean',
        name: 'get-clean',
        component: require('../components/work/GetClean.vue')
      },
      {
        path: 'een',
        name: 'een',
        component: require('../components/work/Een.vue')
      },
      {
        path: 'hey-student',
        name: 'hey-student',
        component: require('../components/work/HeyStudent.vue')
      },
      {
        path: 'by-wood',
        name: 'by-wood',
        component: require('../components/work/ByWood.vue')
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js